import ReactGA from 'react-ga4'

import { store } from '@/store/store'
import { CardType } from '@/types/card'

import { ADD_CARD, POP_REC, SET_VIEWER_IMAGE } from './types'

export type AddCardActionType = {
  payload: CardType[]
  type: typeof ADD_CARD // url
}

const trackAddCard = (label?: string) => {
  ReactGA.event({ action: 'clipboard_add_card', category: 'clipboard', label })
}

export const addCard = (card: CardType | CardType[], recsIndex?: number) => {
  const dispatch = store.dispatch
  const cardArray = Array.isArray(card) ? card : [card]
  if (recsIndex) {
    dispatch({ payload: recsIndex, type: POP_REC })
  }
  const cardArrayWithPartners: CardType[] = []
  cardArray.forEach((card) => {
    trackAddCard(card.name)
    if (card.is_partner) {
      card.cards?.map((card) => cardArrayWithPartners.push(card as any))
    } else {
      cardArrayWithPartners.push(card)
    }
  })
  dispatch({ payload: cardArrayWithPartners, type: ADD_CARD })
  dispatch({ payload: cardArray[0].image_uris[0], type: SET_VIEWER_IMAGE })
}
